import { CENotificationBase } from './ce-notification-base'


export class CENotification extends CENotificationBase {

}